import { fetchJobs, deleteJob } from "../features/jobs/jobSlice";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AllJobs() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { jobs, isLoading } = useSelector((state) => state.job);

  const [filters, setFilters] = useState({
    status: "all",
    search: "",
  });

  useEffect(() => { 
    console.log("Loading jobs");
    dispatch(fetchJobs()); // Fetch jobs when component mounts
  }, [dispatch]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({...filters,[name]: value,});
  };

  const filteredJobs = useMemo(() => {
    const searchText = filters.search.toLowerCase();

    return jobs
      .filter(
        (job) =>
          filters.status === "all" || job.status === filters.status
      )
      .filter(
        (job) =>
          job.company.toLowerCase().includes(searchText) ||
          job.position.toLowerCase().includes(searchText)
      );
  }, [jobs, filters]); // change in jobs or filters will re compute the filteredJobs

  return (
    <div className="container mt-4">
      <h2>All Jobs</h2>

      {isLoading && <div className="text-center">Loading...</div>}

      <div className="row mb-3">
        <div className="col-md-8">
          <input
            name="search"
            className="form-control"
            placeholder="Search jobs..."
            value={filters.search}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-4">
          <select
            name="status"
            className="form-select"
            value={filters.status}
            onChange={handleFilterChange}
          >
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="interview">Interview</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
      </div>

      {filters.status !== "all" && (
        <div className="mb-2">
          <strong>Status:</strong> {filters.status}
        </div>
      )}

      <table className="table table-hover">
        <thead>
          <tr>
            <th>Company</th>
            <th>Position</th>
            <th>Status</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredJobs.map((job) => (
            <tr key={job.id}>
              <td>{job.company}</td>
              <td>{job.position}</td>
              <td>{job.status}</td>
              <td>{new Date(job.createDate).toLocaleDateString()}</td>
              <td className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => navigate(`/edit-job/${job.id}`)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => dispatch(deleteJob(job.id))}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
